export default __webpack_public_path__ + "static/media/img_01.f099809b.jpg";